<div class="search">
  <input
    pInputText
    class="search__input"
    type="text"
    [class.search__long]="searchControl.value"
    [placeholder]="placeholder()"
    [formControl]="searchControl"
  />
  <span class="search__magnifying">
    @if (loading()) {
      <app-progress-spinner />
    } @else {
      <svg icon="search" />
    }
  </span>
  @if (searchControl.value) {
    <svg
      icon="cancel"
      class="search__cancel"
      (click)="resetSearch()"
    />
  }
</div>
